import React, { FC } from 'react';
import { useTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';

import { ServerError500Icon } from 'src/shared/components/icons';
import { getSynerionLogoUrl } from 'src/shared/utils';
import { getCurrentCulture } from 'src/store/localizations/localizations.selectors';

/*
    Notes : Edge cases when the translations api would fail, the following strings are stored at this level.
    If the user's language preference cannot be retrieved as well, then the language is determined using the browser's
    default language.
 */
export const ServerError500Page: FC = () => {
  const theme = useTheme();
  const currentCulture = useSelector(getCurrentCulture);
  const { title, message } = getLocalizedStrings(currentCulture);

  return (
    <div className="h-100 w-100 d-flex align-items-center justify-content-center flex-column">
      <img alt="synerion-logo" src={getSynerionLogoUrl(theme)} width="160" className="mb-5" />
      <ServerError500Icon />
      <div className="px-3 mt-5 text-center">
        <h1 className="h4 fw-medium">{title}</h1>
        <p className="text-muted my-3">{message}</p>
      </div>
    </div>
  );
};

const getLocalizedStrings = (culture: string): { title: string; message: string } => {
  switch (culture.substring(0, 2).toLowerCase()) {
    case 'fr':
      return {
        message: 'Veuillez essayer de nouveau plus tard ou contactez votre administrateur système',
        title: "Désolé! La page à laquelle vous essayez d'accéder ne peut pas être affichée pour le moment",
      };
    case 'es':
    case 'en':
    default:
      return {
        message: 'Please try again later or contact your system administrator',
        title: 'Sorry! The page you’re trying to access cannot be displayed at this time',
      };
  }
};
